import { collect, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { indexed, isEmpty, filter, tryPick } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { $007CReactText$007C_$007C, $007CReactKey$007C_$007C } from "../UI.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { createElement } from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export function Shopfoo_Client_Search_Highlighting__Highlighting_CssClasses_Z779CFBC1(this$, props) {
    return toList(delay(() => {
        if (this$.tag === 0) {
            return append(((props & 1) !== 0) ? singleton("border-yellow-400") : empty(), delay(() => append(((props & 2) !== 0) ? singleton("rounded-sm border-1") : empty(), delay(() => (((props & 4) !== 0) ? singleton("bg-yellow-200 text-black") : empty())))));
        }
        else {
            return empty();
        }
    }));
}

/**
 * Highlights matches of the given <c>SearchTargetResult</c> in the text content of the given React element.
 */
export function Highlight_matches(element, props, result) {
    let copyOfStruct;
    const highlightingClasses = Shopfoo_Client_Search_Highlighting__Highlighting_CssClasses_Z779CFBC1(result.Highlighting, 7);
    const reactKey = defaultArg(map(toString, tryPick($007CReactKey$007C_$007C, props)), ((copyOfStruct = newGuid(), copyOfStruct)).slice(undefined, 7 + 1));
    const otherProps = filter((_arg) => {
        let matchResult;
        if ($007CReactKey$007C_$007C(_arg) != null) {
            matchResult = 0;
        }
        else if ($007CReactText$007C_$007C(_arg) != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return false;
            default:
                return true;
        }
    }, props);
    return element(isNullOrWhiteSpace(result.Text) ? props : (isEmpty(result.Matches) ? toList(delay(() => append(props, delay(() => singleton(["children", result.Text]))))) : toList(delay(() => append(singleton(["key", reactKey]), delay(() => append(otherProps, delay(() => {
        let elems;
        return singleton((elems = toList(delay(() => collect((matchValue) => {
            const m = matchValue[1];
            let matchResult_1;
            if (isEmpty(highlightingClasses)) {
                matchResult_1 = 0;
            }
            else if (m.MatchType.tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
            }
            switch (matchResult_1) {
                case 0:
                    return singleton(m.Text);
                default:
                    return singleton(createElement("mark", {
                        key: `${reactKey}-match-${matchValue[0]}`,
                        className: join(" ", highlightingClasses),
                        children: m.Text,
                    }));
            }
        }, indexed(result.Matches)))), ["children", reactApi.Children.toArray(Array.from(elems))]));
    }))))))));
}

